import { createClient, SupabaseClient } from '@supabase/supabase-js';

let cached: SupabaseClient | null = null;
let warned = false;

export function getSupabase(): SupabaseClient | null {
  if (cached) return cached;

  const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
  const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

  if (!url || !key) {
    if (!warned) {
      console.warn('[SupabaseClient] missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY; tracking disabled.');
      warned = true;
    }
    return null;
  }

  cached = createClient(url, key, {
    auth: { persistSession: false },
  });
  return cached;
}
